// extracted by mini-css-extract-plugin
export var modalFooter = "_qg-0";